import React, { useEffect, useState } from "react";
import apicalls from "../../api/apiCalls";
import { connect } from "react-redux";
import InfiniteScroll from "react-infinite-scroll-component";
import moment from "moment/moment";
import Loader from "../../shared/loader";
import { Empty,Tooltip,Input } from "antd";
import { utils, writeFile } from 'xlsx';
import Breadcrumb from "../../layout/componentsBreadcrumb";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import AppTitle from "../../shared/appTitle";
import AppRow from "../../shared/appRow";
import AppAlert from "../../shared/appAlert";
import AppCol from "../../shared/appCol";
import { debouncedGrid } from "./service";
import { getTransactions } from "./api";

const Transactions = (props) => {
  const [searchGridDataFilter, setSearchGridDataFilter] = useState([]);
  const [loader, setLoader] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [searchQuery, setSearchQuery] = useState(null);
  const history = useHistory()
  const [pageNo, setPageNo] = useState(1);
  let pageSize = 20
  const { Search } = Input;
  const breadCrumbList = [
    { id: "1", bname: "Payment Artha",url : '/dashboard' },
    { id: "2", bname: "Transactions" }
  ];
  const [totalGridDataCount, setTotalGridDataCount] = useState(50)
  const btnColourList = {
    Success: "table-text td-success",
    Submitted: "table-text td-success",
    Approved: "table-text td-success",
    Cancelled: "table-text text-red",
    Rejected: "table-text text-red",
    Pending: "table-text text-blue",
  };
  const iconColourList = {
    Deposit: "icon md deposit",
    Withdraw: "icon md withdraw",
  };

  useEffect(() => {
    getTransactionGrid(0,props?.userConfig?.id,null,pageNo)
  }, []);

  const fetchMoreData = () => {
    if (searchGridDataFilter.length < totalGridDataCount) {
      getTransactionGrid(0,props.userConfig.id,searchQuery || null,pageNo);
    }
  };
  const gridCallback=(data,error)=>{
    if(data){
      setPageNo(prevPageNo => prevPageNo + 0)
      setSearchGridDataFilter(prevData => [...prevData, ...data.data]);
      setLoader(false)
      setTotalGridDataCount(data.total)
      setErrorMessage(null);
      return
    }
    setErrorMessage(error)
    setLoader(false)
  }
  const getTransactionGrid = async (timeout,id,search,pageNumber) => {
     setLoader(true);
    debouncedGrid(timeout,id,search,gridCallback,pageNumber,pageSize)
  };

  const handleSearchGrid = (e) => {
    const searchList = e.target.value;
    setSearchQuery(searchList);
    setSearchGridDataFilter([])
    setPageNo(1)
    setLoader(true)
    setTotalGridDataCount(50)
    if (searchList === "") {
      getTransactionGrid(1000,props?.userConfig?.id,null,pageNo)
    } else {
      getTransactionGrid(1000,props?.userConfig?.id, searchList,1)
    }
  };
  const handleExportToExcel = async () => {
    const response = await getTransactions(props?.userConfig?.id, searchQuery);
    if (response.ok) {
      const dataToExport = response.data.data;
      const excelData = dataToExport.map((item) => {
        return {
          "Transaction ID":item.txId||-"-",
          "Date": moment.utc(item.date).local().format("DD/MM/YYYY hh:mm:ss A") || "-",
          "Transaction Type": item.txType || "-",
          "Wallet": item.wallet || "-",
          "Value": item.value,
          "Status": item.state || "-",
          "Reason for Rejection":item?.reasonForRejection
        };
      });
      const worksheet = utils.json_to_sheet(excelData);
      const workbook = utils.book_new();
      utils.book_append_sheet(workbook, worksheet, 'Sheet 1');

      const columnWidths = [{ wch: 22 },{ wch: 22 }, { wch: 22 }, { wch: 22 }, { wch: 15 }, { wch: 15 }, { wch: 25 }];
      worksheet['!cols'] = columnWidths;

      writeFile(workbook, 'TransactionData.xlsx');

      setErrorMessage(null);
    } else {
      setErrorMessage(apicalls.isErrorDispaly(response));
    }
  };

  const handleOpen = (item) => {
    history.push(`/transactionDetails/${item?.id}/${item?.txType}`)
  }

  return (
    <>
      <div className='d-flex align-start transactions-header'>
        <Breadcrumb breadCrumbList={breadCrumbList} />
        <div className="d-flex align-center transactions-search">
          <div className="coin-search mb-0">
            <Search value={searchQuery} placeholder='Search Transaction' suffix={<span className="icon md search c-pointer" />}
              onChange={handleSearchGrid} size="middle" bordered={false} className="coin-search-input " />
          </div>
          <div className="text-right export-pdf secureDropdown">
            <Tooltip placement="top" title={"Export Excel"}>
              <button className="c-pointer btn-style"
                onClick={() => {
                  handleExportToExcel()
                }}
              >
                <span>Export Excel</span>
                <span
                  className="icon xl mr-0 excelexport"
                ></span></button>
            </Tooltip>
          </div>
        </div>

      </div>
      <AppRow>
        {errorMessage !== undefined && errorMessage !== null && errorMessage !== "" && (
          <div className="alert-flex" style={{ width: "100%" }}>
            <AppAlert
              className="w-100 "
              type="warning"
              description={errorMessage}
              showIcon
            />
            <button className="icon sm alert-close" onClick={() => setErrorMessage(null)}></button>
          </div>
        )}
        <AppCol xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
          <div className="layout-bg left-panel pannel-bg mt-14 sm-m-0 transactions-scroll">
            <InfiniteScroll
              className="table-scroll"
              dataLength={searchGridDataFilter?.length}
              next={fetchMoreData}
              hasMore={searchGridDataFilter?.length < totalGridDataCount}
              endMessage={
                <div className="text-center">
                  {searchGridDataFilter?.length!==0 && <span className="text-white">Yay! You have seen it all </span>}
                </div>}
            >
              <div>
                {searchGridDataFilter && <>
                  {searchGridDataFilter?.map(item =>
                    <div className="table-grid" key={item.id}>
                      <div className="custom-table card d-flex justify-content transactions">
                        <div className="flex-width"><label htmlFor className="table-label">Transaction ID</label><AppTitle level={4} className="table-text c-pointertransaction-id-text text-link c-pointer" onClick={() => handleOpen(item)}>{item?.txId}</AppTitle></div>
                        <div className=" justify-content align-center transaction-date"><div><span
                          className={iconColourList[item.doctype]}
                        ></span></div><div className="table-date"><label htmlFor className="table-label">
                          Date</label><AppTitle level={4} className="table-text" >
                              {item?.date ? <>{moment.utc(item?.date).local().format("DD/MM/YYYY hh:mm:ss A")}</> : item?.date}</AppTitle></div></div>
                        <div className="flex-width"><label htmlFor className="table-label">Transaction Type</label><AppTitle level={4} className="table-text">{item?.txType}</AppTitle></div>
                        {/* <div className="flex-width"><label htmlFor className="table-label">Type</label><AppTitle level={4} className="table-text">{item?.type}</AppTitle></div> */}
                        <div className="flex-width"><label htmlFor className="table-label">Wallet</label><AppTitle level={4} className="table-text">{item?.wallet}</AppTitle></div>
                        <div className="flex-width value-feild"><label htmlFor className="table-label">Value</label><AppTitle level={4} className="table-text">{item.value}
                        </AppTitle></div>
                        <div className="flex-width"><label htmlFor className="table-label">Status</label><AppTitle level={4}
                          className={item.state === "Approved (Sent)" && "table-text td-success" || btnColourList[item.state]}>
                          {item?.state ? item?.state : "-"}
                        </AppTitle>
                        </div>
                        {/* <div className="flex-width"><label htmlFor className="table-label">Reason For Rejection</label><AppTitle level={4} className="table-text">{item?.reasonForRejection||"--"}</AppTitle></div> */}
                      </div>
                    </div>
                  )}</>}
              </div>
              {searchGridDataFilter?.length === 0 && !loader && <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description="No Data"
              ></Empty>}
            </InfiniteScroll>
              <Loader spinning={loader} />
          </div>
        </AppCol >
      </AppRow >
    </>
  );
};
const connectStateToProps = ({ userConfig }) => {
  return {
    userConfig: userConfig.userProfileInfo
  }
}
export default connect(connectStateToProps)(Transactions);